module.exports = "/img/d14c6b102f96e6966c4817a001089ee7.svg";